var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',{class:[ ("language-" + _vm.lang) ]},[_vm._v("  "),_c('code',[_vm._v(_vm._s(_vm.content))]),_vm._v("\n")])}
var staticRenderFns = []

export { render, staticRenderFns }